var ConsultationSection = function () {
  var alreadyAnimated = false
  var showConsultationPart = function (selector, callback) {
    $(selector).animate({
      top: '-3px',
      opacity: 1
    }, {
      duration: 400,
      complete: callback
    })
  }

  var animateMessages = function () {
    if (!alreadyAnimated) {
      showConsultationPart('.consultation__animation__question', function () {
        window.setTimeout(function () {
          showConsultationPart('.consultation__animation__answer-gp', function () {
            window.setTimeout(function () {
              showConsultationPart('.consultation__animation__answer-spec', function () {
                alreadyAnimated = true
              })
            }, 1000)
          })
        }, 1000)
      })
    }
  }

  var init = function () {
    $(document).ready(function () {
      if (IntersectionObserver) {
        const observer = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) {
            animateMessages()
          }
        })

        var elementToObserve = document.querySelector('#consultation-introduction-bubbles')
        if (elementToObserve) {
          observer.observe(elementToObserve)
        }
      } else {
        animateMessages()
      }
    })
  }

  return {
    init: init
  }
}()

UL.register(ConsultationSection)
